// src/hooks/usePublicSurvey.ts
import { useMutation, useQuery } from "@tanstack/react-query";
import { openPublicSurvey, submitPublicSurvey } from "@/services/publicSurvey";
import type { PublicSurveySubmitIn } from "@/types/publicSurvey";

export function usePublicSurvey(token: string | undefined) {
  return useQuery({
    queryKey: ["public_survey", token],
    queryFn: () => openPublicSurvey(token as string),
    enabled: !!token,
    staleTime: 10_000,
    retry: false,
  });
}

export function useSubmitPublicSurvey(token: string) {
  return useMutation({
    mutationFn: (body: PublicSurveySubmitIn) => submitPublicSurvey(token, body),
  });
}
